export function SEPARATOR__horizontal_dashed() {
  return <div className="w-full border-t border-component-item border-dashed" />;
}
